<template>
    <section class="my_6 qr_container mt_40" :class="{'grid_2': isTwoCol}">
        <aside class="qr_img">
            <div v-if="qr_code">
            <span  class="counter font_700">{{count}}</span> sec
            </div>
            <div v-if="qr_code">
                <img :src="qr_code" alt="">
            </div>
            <div class="mt_10" v-else>
                <p>{{$t('INBOX_MGMT.ADD.WHATSAPP_PERSONAL.QR_CODE_SCAN.NO_QR_CODE_MSG')}}</p>
                <woot-button @click="getNewQRCode(true)" :is-disabled="isFetchingQr" :is-loading="isFetchingQr">
                    {{$t('INBOX_MGMT.ADD.WHATSAPP_PERSONAL.QR_CODE_SCAN.GENERATE_QR_BTN')}}
                </woot-button>
            </div>
        </aside>
        <aside>
            <h3 class="text_16" style="color: #3c4858;">{{$t('INBOX_MGMT.ADD.WHATSAPP_PERSONAL.QR_CODE_SCAN.INSTRUCTIONS.TITLE')}}</h3>
            <ul class="instructions mt_20">
                <li class="text_14 my_4"> 1) {{$t('INBOX_MGMT.ADD.WHATSAPP_PERSONAL.QR_CODE_SCAN.INSTRUCTIONS.LIST.OPEN')}}</li>
                <li class="text_14 my_4"> 2)
                    {{$t('INBOX_MGMT.ADD.WHATSAPP_PERSONAL.QR_CODE_SCAN.INSTRUCTIONS.LIST.TAP.TAP')}}
                    <span class="font_700">
                    {{$t('INBOX_MGMT.ADD.WHATSAPP_PERSONAL.QR_CODE_SCAN.INSTRUCTIONS.LIST.TAP.MENU')}}
                    </span>
                    <span class="inline_icon">
                        <span>
                        <fluent-icon icon="more-vertical" />
                        </span>
                    </span>
                    {{$t('INBOX_MGMT.ADD.WHATSAPP_PERSONAL.QR_CODE_SCAN.INSTRUCTIONS.LIST.TAP.ANDROID')}}
                    <span class="font_700">
                    {{$t('INBOX_MGMT.ADD.WHATSAPP_PERSONAL.QR_CODE_SCAN.INSTRUCTIONS.LIST.TAP.SETTINGS')}}
                    </span>
                    <span class="inline_icon">
                        <span>
                        <fluent-icon icon="settings" />
                        </span>
                    </span>
                    {{$t('INBOX_MGMT.ADD.WHATSAPP_PERSONAL.QR_CODE_SCAN.INSTRUCTIONS.LIST.TAP.IPHONE')}}
                </li>
                <li class="text_14 my_4"> 3)
                    {{$t('INBOX_MGMT.ADD.WHATSAPP_PERSONAL.QR_CODE_SCAN.INSTRUCTIONS.LIST.LINK_DEVICE.TAP')}}
                    <span class="font_700">
                    {{$t('INBOX_MGMT.ADD.WHATSAPP_PERSONAL.QR_CODE_SCAN.INSTRUCTIONS.LIST.LINK_DEVICE.DEVICE')}}
                    </span>
                    {{$t('INBOX_MGMT.ADD.WHATSAPP_PERSONAL.QR_CODE_SCAN.INSTRUCTIONS.LIST.LINK_DEVICE.AND')}}
                    <span class="font_700">
                    {{$t('INBOX_MGMT.ADD.WHATSAPP_PERSONAL.QR_CODE_SCAN.INSTRUCTIONS.LIST.LINK_DEVICE.LINK')}}
                    </span>
                </li>
                <li class="text_14 my_4"> 4) {{$t('INBOX_MGMT.ADD.WHATSAPP_PERSONAL.QR_CODE_SCAN.INSTRUCTIONS.LIST.SCAN_QR.POINT')}}</li>
                <li class="text_14 my_4"> 5) {{$t('INBOX_MGMT.ADD.WHATSAPP_PERSONAL.QR_CODE_SCAN.INSTRUCTIONS.LIST.WAIT')}}</li>
            </ul>
        </aside>
    </section>
</template>

<script>
import { mapGetters } from 'vuex';
import alertMixin from 'shared/mixins/alertMixin';
import { required } from 'vuelidate/lib/validators';
import {WP_PERSONAL_EVENTS} from "./channels/constant";
import router from '../../../../routes/index';
import InboxApi from 'dashboard/api/inboxes.js'



export default {
    mixins: [alertMixin],
    props:{
        inboxName:{
            type: String,
            required: true,
        },
        isTwoCol:{
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            qr_code: null,
            count: 60,
            qrRefreshInterval: null,
            timerInterval: null,
            isFetchingQr:false,
        };
    },
    mounted() {
        const personalQRcodeName = "whatsapp_personal_QR";
        const qr_code = sessionStorage.getItem(personalQRcodeName);
        if (qr_code) {
            this.qr_code = qr_code;
        }else{
            this.getNewQRCode();
        }

        // Restore count from sessionStorage
        const savedCount = sessionStorage.getItem("whatsapp_qr_count");
        this.count = savedCount ? parseInt(savedCount, 10) : 60;

        bus.$on(WP_PERSONAL_EVENTS.ON_QR_SCANED,(data)=>{
            console.log(data,"QR scanned",this.inboxName);
            // call to create inbox and navigate to add agent
            // const inboxName = sessionStorage.getItem("whatsapp_personal_inbox_name");
            if(data.id && data.name === this.inboxName.replace(/ /g, "_")) {
                sessionStorage.removeItem(personalQRcodeName);
                sessionStorage.removeItem("whatsapp_qr_count");
                sessionStorage.removeItem('whatsapp_personal_inbox_name');
                clearInterval(this.qrRefreshInterval); // Stop refreshing on success
                clearInterval(this.timerInterval);
                this.$emit("onCreateChannel",data);
                // emit event click @onCreateChannel(data.id)
                // this.createChannel(data.id);
            }

        })
        // Start timers
        this.startTimers();

    },
    beforeDestroy() {
        clearInterval(this.timerInterval);
        clearInterval(this.qrRefreshInterval);
    },
    methods: {
        async getNewQRCode(isReset) {
            try {
                // const inboxName = sessionStorage.getItem("whatsapp_personal_inbox_name");
                if (!this.inboxName) {
                clearInterval(this.qrRefreshInterval);
                return
                }
                this.isFetchingQr = true;
                const { data } = await InboxApi.generateWaPersonalQR({ name: this.inboxName });


                this.qr_code = data.qr;
                sessionStorage.setItem("whatsapp_personal_QR", this.qr_code);
                if (data.connected) {
                    this.$emit("onChannelConnected",data);
                }
                this.isFetchingQr = false;


                if (isReset) {
                    // ✅ Reset counter
                    this.count = 60;
                    sessionStorage.setItem("whatsapp_qr_count", this.count);

                    // ✅ Restart timers
                    clearInterval(this.timerInterval);
                    clearInterval(this.qrRefreshInterval);
                    this.startTimers();
                }

            } catch (error) {
                console.error("Failed to refresh QR:", error);
                this.isFetchingQr = false;
            }
        },
        startTimers() {
            // if (!this.qr_code) return;

            // Timer for countdown
            this.timerInterval = setInterval(() => {
                this.count--;
                sessionStorage.setItem("whatsapp_qr_count", this.count); // Persist count
                if (this.count <= 0 && this.qr_code) {
                    this.showAlert(`QR code session expired!`)
                    clearInterval(this.timerInterval);
                    clearInterval(this.qrRefreshInterval);
                    sessionStorage.removeItem("whatsapp_personal_QR");
                    sessionStorage.removeItem("whatsapp_qr_count");
                    this.qr_code = null;
                    // this.$emit("onQRSessionTimout",);
                    // emit event click @onQRSessionTimout
                    // this.$router.push(`/app/accounts/${this.currentUser.account_id}/settings/inboxes/new/whatsapp_personal`);
                }
            }, 1000); // every 1 second


            this.qrRefreshInterval = setInterval(() => {
                if (this.qr_code) {
                    this.getNewQRCode();
                }
            }, 20000); // every 20 seconds
        },

    },

}
</script>




<style lang="scss" scoped>
@import '~dashboard/assets/scss/widgets/_fonts.scss';

.qr_container{
    display: grid;
    gap: 1rem;

    .qr_img{
        width: fit-content;
        text-align: center;

        .counter{
        font-size: 40px;
        color: #6F1DDF;
        }
    }
}

.grid_2{
    grid-template-columns: 340px 1fr;
}

.instructions{
    list-style: none;
    text-align: left;
    color: #3c4858;
}
.inline_icon{
    position: relative;
    display: inline-block;
    width: 16px;
    height: 14px;
    span{
        position: absolute;
        top: 0;
        left: 0;
    }
}
</style>

